module.exports = __webpack_public_path__ + "static/media/sm.43f77804.jpg";